import axios from "axios";
import { URL_BASE } from "../config/url-server";


const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")




export const firstApplicationByWeek = async (startDate, endDate,farmId,lotId,sectionId,lots) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/first-application-week",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const applicationsByWeek = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/applications-by-week",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};





export const hectaresByWeek = async (startDate, endDate,farmId,lotId,sectionId,lots,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,lots,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "dashboard/hectares-by-week",
      config
    );
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};





export default {
  firstApplicationByWeek,
  applicationsByWeek,
  hectaresByWeek
};
